import { render } from "./XIconSolidKeyRound.vue?vue&type=template&id=6cb074a2"
import script from "./XIconSolidKeyRound.vue?vue&type=script&lang=js"
export * from "./XIconSolidKeyRound.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidKeyRound.vue"]])

export default __exports__